import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useFeatures } from "components/FeatureFlag";
import Modal from "components/Modal";

import { useUseCasesWidgetVisibility } from "scenes/Settings/components/HubSettings/components/HubOptions/hooks";

function SkipUseCasesWidgetModal({ onClose }) {
  const useCasesWidgetFF = useFeatures("onboarding-use-cases-widget");
  const { updateUseCaseVisibility, isUpdatingUseCaseVisibility } =
    useUseCasesWidgetVisibility();

  return (
    <Modal
      data-test="skip-use-cases-widget-modal"
      size="small"
      isModalOpen
      onClose={onClose}
    >
      <Modal.Header onClose={onClose}>
        {useCasesWidgetFF?.skipUseCasesWidgetModal?.title ||
          "Are you sure you want to proceed without selecting a use case?"}
      </Modal.Header>
      <Modal.Body>
        {useCasesWidgetFF?.skipUseCasesWidgetModal?.body ||
          "We highly recommend you select a use case to get started. " +
            "They were built by our team to help you quickly get you up and running with Hubly."}
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="button"
          basic
          onClick={async () => {
            await updateUseCaseVisibility(false);
            onClose();
          }}
          disabled={isUpdatingUseCaseVisibility}
        >
          {useCasesWidgetFF?.skipUseCasesWidgetModal?.cancelButton ||
            "Yes, I feel confident using Hubly by myself"}
        </Button>
        <Button
          primary
          onClick={() => {
            onClose();
          }}
          loading={isUpdatingUseCaseVisibility}
          disabled={isUpdatingUseCaseVisibility}
        >
          {useCasesWidgetFF?.skipUseCasesWidgetModal?.confirmButton ||
            "No, I want to select my first use case"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

SkipUseCasesWidgetModal.propTypes = { onClose: PropTypes.func.isRequired };

SkipUseCasesWidgetModal.defaultProps = {};

export default SkipUseCasesWidgetModal;
